import React from 'react';
import { Form, Formik } from 'formik';

import { useToast } from 'helpers/hooks';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { Modal } from 'components/Modal';
import { request } from 'helpers/tools';
import styles from 'css_modules/Modal.module.css';

export const ShareModal = ({ close, doc }) => {
  const showToast = useToast();

  const handleShare = async (values) => {
    if (!values.subject?.trim()) {
      showToast('Vyplňte předmět e-mailu');
      return;
    }

    close();
    try {
      const response = await request(
        '/send_doc_via_email/',
        'POST',
        {
          uuid: doc?.uuid,
          email: values.email,
          subject: values.subject,
          body: values.body,
        }
      );

      if (response && response.ok !== false) {
        showToast('Doklad byl úspěšně odeslán na e-mail');
      } else {
        showToast('Chyba při odesílání dokladu');
      }
    } catch {
      showToast('Chyba při odesílání dokladu');
    }
  };

  return (
    <div className={styles.ontop}>
      <Modal name={doc?.name || 'Sdílet doklad'} close={close}>
        <Formik
          initialValues={{
            email: '',
            subject: '',
            body: '',
          }}
          onSubmit={handleShare}
        >
          <Form>
            <Input name="email" type="email" className={styles.body} required>
              E-mailová adresa
            </Input>
            <Input name="subject" type="text" className={styles.body} required>
              Předmět zprávy
            </Input>
            <Input name="body" component="textarea" rows="5" className={styles.body}>
              Zpráva (volitelné)
            </Input>
            <div className={styles.buttons}>
              <Button onClick={close}>Zavřít</Button>
              <Button primary type="submit">
                Odeslat
              </Button>
            </div>
          </Form>
        </Formik>
      </Modal>
    </div>
  );
};